import { UriBuilder } from 'uribuilder';
import { User } from '../components/client-panel/components/my-account-info/models/user.model';

const handleRedirectToCalaculationProgram = (redirectUrl: string, userDetails: User): any => {
    window.location.href = getUriToCalaculationProgram(redirectUrl, userDetails);
};

export const getUriToCalaculationProgram = (redirectUrl: string, userDetails: User): string => {
    const token: string | null = localStorage.getItem('token');
    const builder = UriBuilder.parse(`${process.env.REACT_APP_OLD_FIXCENTER_URL}CalculationProgram/Login` as string);
    builder.query.username = userDetails?.email ? userDetails.email : '';
    builder.query.token = token ? token : '';
    builder.query.redirectUrl = redirectUrl;
    return builder.toString();
};

export const redirectToCalaculationProgram = (userDetails: User): any => {
    handleRedirectToCalaculationProgram('StrenooxProject/List', userDetails);
};

export const redirectToCalaculationProgramDemo = (userDetails: User): any => {
    handleRedirectToCalaculationProgram('StaticCalculation/Demo', userDetails);
};
